import { t } from '@lingui/core/macro'
import React from 'react'
import { Accordion, Divider, Tooltip } from '@tecsinapse/cortex-react'
import { TriggerAccordion } from './trigger-accordion'
import { useGrupos } from '@/core/hooks/use-grupos'
import { useRealmLabels } from '@/core/hooks/use-realm-labels'
import { FaQuestionCircle } from 'react-icons/fa'
import { FormMultiSelect } from '../../hook-form-connectors/form-multi-select'
import { getLabel } from '@/core/utils/global-labels'

interface AccordionGruposProps {
  possuiGrupos?: boolean
}

export const AccordionGrupos = ({ possuiGrupos }: AccordionGruposProps) => {
  const { gruposOptions } = useGrupos()
  const realmLabels = useRealmLabels()

  return (
    <div className={'mt-deca border border-secondary-light rounded-mili '}>
      <Accordion.Face direction={'vertical'}>
        <TriggerAccordion
          labelCheboxbox={t`Por ${getLabel('label.grupos')}`}
          idCheckbox={'possuiGrupos'}
          value={possuiGrupos}
          fieldToClear='grupos'
        />
        <Accordion.Content direction={'vertical'}>
          <Divider />
          <div className={'p-deca h-[15rem]'}>
            <div className={'sm:w-[50%] flex items-center gap-2'}>
              <FormMultiSelect
                name='grupos'
                label={getLabel('label.grupos')}
                options={gruposOptions}
                className='col-span-1'
                withSearch
              />
              {realmLabels.has('grupo.dealer') ? (
                <Tooltip text={realmLabels.get('grupo.dealer')}>
                  <FaQuestionCircle className='text-gray-400 cursor-help' />
                </Tooltip>
              ) : null}
            </div>
          </div>
        </Accordion.Content>
      </Accordion.Face>
    </div>
  )
}
